import React from "react";
import { Box } from "@mui/material";

const Etiqueta = ({ children }) => (
  <Box sx={{ px: 1.25, py: 0.25, fontSize: 12.5, lineHeight: 1.2, fontWeight: 600, color: "text.secondary", display: "flex", alignItems: "center" }}>{children}</Box>
);

const Valor = ({ children, alto, control }) => (
  <Box sx={{ px: 0.5, py: 0.2, display: "flex", alignItems: alto ? "stretch" : "center", minWidth: 0 }}>
    {control ? <Box sx={{ flex: 1, minWidth: 0 }}>{control}</Box> : <Box
      sx={{
        flex: 1, minHeight: alto ? 52 : 28, px: 1, py: 0.25, borderRadius: 0, bgcolor: "action.hover", border: 1, borderColor: "divider",
        fontSize: 12.5, wordBreak: "break-word", whiteSpace: "pre-wrap", display: "flex", alignItems: alto ? "flex-start" : "center",
      }}
    >
      {children}
    </Box>}
  </Box>
);

// Marco de la ficha: las filas (FilaFicha) van dentro.
export const FichaContenedor = ({ children }) => (
  <Box sx={{ border: 1, borderColor: "divider", borderRadius: 1.5, bgcolor: "background.paper", overflow: "hidden", fontVariantNumeric: "tabular-nums",
      // Controles compactos: misma altura y letra que los recuadros de solo lectura.
      // El tema de la app da margen a cada FormControl; dentro de la ficha no hace falta.
      "&& .MuiFormControl-root": { margin: 0 },
      "&& .MuiInputBase-root": { fontSize: 12.5, minHeight: 28, borderRadius: 0, py: 0 },
      "&& .MuiOutlinedInput-input": { py: "4px", px: "10px" },
      "&& .MuiSelect-select": { py: "4px", minHeight: "unset" },
      "&& .MuiAutocomplete-inputRoot": { py: "0 !important", pl: "4px" },
      "&& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": { py: "4px", px: "6px" },
      "&& .MuiOutlinedInput-root.MuiInputBase-multiline": { py: "4px" },
      "&& .MuiInputAdornment-root p": { fontSize: 12.5 },
      "&& .MuiToggleButton-root": { py: "3px", fontSize: 12.5, borderRadius: 0 },
      "&& .MuiToggleButtonGroup-root": { borderRadius: 0 },
      "&& .MuiFormControlLabel-label": { fontSize: 12.5 },
      "&& .MuiCheckbox-root": { py: 0.25 },
      "&& .MuiAutocomplete-endAdornment": { right: "2px" },
    }}>{children}</Box>
);

// Una fila de la ficha: una o dos parejas etiqueta + valor.
export const FilaFicha = ({ campos }) => (
  <Box
    sx={{
      display: "grid", borderBottom: 1, borderColor: "divider", "&:last-child": { borderBottom: 0 },
      gridTemplateColumns: { xs: "100px minmax(0, 1fr)", sm: campos.length > 1 ? "122px minmax(0, 1fr) 122px minmax(0, 1fr)" : "122px minmax(0, 1fr)" },
    }}
  >
    {campos.map((c) => (
      <React.Fragment key={c.etiqueta}>
        <Etiqueta>{c.etiqueta}</Etiqueta>
        <Valor alto={c.alto} control={c.control}>{c.valor || ""}</Valor>
      </React.Fragment>
    ))}
  </Box>
);

// Ficha de solicitud de cheque con el mismo orden que el formulario del sistema anterior (etiqueta a la izquierda, dato en recuadro gris).
// `extras` agrega filas opcionales al final (cliente, facturas, archivos…).
export default function FichaSolicitud({ fecha, cambio, dirigido, deposito, ciudad, servicio, moneda, tipoEgreso, importeBs, importeUsd, concepto, mes, proyecto, observacion, extras = [] }) {
  const filas = [
    [{ etiqueta: "Fecha de registro", valor: fecha }, { etiqueta: "Tipo de cambio", valor: cambio }],
    [{ etiqueta: "Dirigido a", valor: dirigido }],
    [{ etiqueta: "Depositado a", valor: deposito }],
    [{ etiqueta: "Ciudad destino", valor: ciudad }, { etiqueta: "Tipo de servicio", valor: servicio }],
    [{ etiqueta: "Moneda", valor: moneda }, { etiqueta: "Tipo de egreso", valor: tipoEgreso }],
    [{ etiqueta: "Importe en Bs", valor: importeBs }, { etiqueta: "Importe en $us", valor: importeUsd }],
    [{ etiqueta: "Concepto", valor: concepto }],
    [{ etiqueta: "Mes de servicio", valor: mes }],
    [{ etiqueta: "Proyecto", valor: proyecto }],
    [{ etiqueta: "Observación", valor: observacion, alto: true }],
    ...extras.filter((x) => x && x.valor).map((x) => [{ etiqueta: x.etiqueta, valor: x.valor, alto: x.alto }]),
  ];
  return (
    <FichaContenedor>
      {filas.map((campos) => <FilaFicha key={campos[0].etiqueta} campos={campos} />)}
    </FichaContenedor>
  );
}

